import { Actor } from "../actor.js";
import { Layer } from "../tile.js";
import { Key } from "./items.js";
import { actorDB } from "../const.js";
export class NoSign extends Actor {
    constructor() {
        super(...arguments);
        this.id = "noSign";
    }
    getLayer() {
        return Layer.ITEM_SUFFIX;
    }
    blocks(other) {
        var _a;
        const item = this.tile[Layer.ITEM];
        if (item instanceof Key) {
            if (((_a = other.inventory.keys[item.id]) === null || _a === void 0 ? void 0 : _a.amount) > 0)
                return true;
        }
        else if (other.inventory.items.some(otherItem => otherItem.id === (item === null || item === void 0 ? void 0 : item.id)))
            return true;
        return false;
    }
}
NoSign.tags = ["ignoreItem", "no-sign"];
actorDB["noSign"] = NoSign;
//# sourceMappingURL=itemMods.js.map